export const UPDATE_SELECTED_CONTRIBUTION = "UPDATE_SELECTED_CONTRIBUTION";

export const updateSelectedContribution = (contribution) => ({
  type: UPDATE_SELECTED_CONTRIBUTION,
  payload: contribution,
});
